import React from 'react';
import { Search, Users, MessageSquare, User, ShieldCheck } from 'lucide-react'; // أيقونات احترافية
import './BottomNav.css';
import { triggerHaptic } from '../utils/haptics';

const BottomNav = ({ activeTab, setActiveTab, isAdmin, friendsUnreadCount }) => {
  const handleTabClick = (tabId) => {
    if (activeTab !== tabId) {
      triggerHaptic('light');
      setActiveTab(tabId);
    }
  };

  return (
    <nav className="bottom-nav" aria-label="شريط التنقل السفلي">
      <button
        className={`nav-item ${activeTab === 'match' ? 'active' : ''}`}
        onClick={() => handleTabClick('match')}
      >
        <Search className="nav-icon" />
        <span className="nav-label">المطابقة</span>
      </button>

      <button
        className={`nav-item ${activeTab === 'friends' ? 'active' : ''}`}
        onClick={() => handleTabClick('friends')}
      >
        <div className="nav-icon-wrapper" style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
          <Users className="nav-icon" />
          {friendsUnreadCount > 0 && (
            <span className="nav-badge" style={{
              position: 'absolute',
              top: '-6px',
              right: '-6px',
              backgroundColor: '#ef4444',
              color: '#fff',
              borderRadius: '50%',
              padding: '2px 5px',
              fontSize: '0.65rem',
              fontWeight: 'bold',
              lineHeight: '1',
              minWidth: '15px',
              textAlign: 'center',
              border: '2px solid var(--nav-bg, #111b21)'
            }}>
              {friendsUnreadCount}
            </span>
          )}
        </div>
        <span className="nav-label">الأصدقاء</span>
      </button>



      {isAdmin && (
        <button
          className={`nav-item admin-tab ${activeTab === 'admin' ? 'active' : ''}`}
          onClick={() => handleTabClick('admin')}
        >
          <ShieldCheck className="nav-icon" />
          <span className="nav-label">الإدارة</span>
        </button>
      )}
    </nav>
  );
};

export default BottomNav;

